
import React, { Component } from 'react';
import { Modal, Radio } from 'antd';
import { getCookie, hexToRgba,hexToRgbaObj } from '../../util/theme.js'
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
class Theme extends Component {
    state = {
        value: 'default',
        themeColor: '',
        firstTheme: '',
        firstCustomColor:'',
        displayColorPicker: false,
        color: {
            r: '0',
            g: '0',
            b: '0',
            a: '1',
        },
        customColor: '#000000',
        secondRgba: '',
        logotype:'',
        firstlogotype:'',
    };
    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    // 获取自定义颜色
    handleChange = (color) => {
        this.setState({
            color: color.rgb,
            customColor: color.hex
        })
        this.changeColor(color.hex);
    };

    // 颜色选择器选择完后刷新颜色
    changeColor = (color) => {
        let rgba = hexToRgba(color);  // 将颜色转换为rgba
        document.documentElement.style.setProperty('--customTheme', color)
        document.documentElement.style.setProperty('--secondTheme', rgba.rgba)
    }

    loadTheme=()=> {
        let type = getCookie('type');
        let customColor = getCookie('customColor');
        let firstTheme = getCookie('type');
        let firstCustomColor = getCookie('customColor');
        let firstlogotype = ''
        if (type === '') {// 第一加载判断cookie是否有存主题色
            type = 'default';
            document.cookie = 'type=' + type;
            this.setState({
                value: 'default',
            })
            firstlogotype = 'other'
        } else{
            if (type === 'custom') {
                // 如果有存在主题色，判断是否为自定义颜色
                let rgbaobj = hexToRgbaObj(customColor); // 获取rgba对象重新初始化颜色选择器
                this.setState({
                    color:{
                        r:rgbaobj.r,
                        g:rgbaobj.g,
                        b:rgbaobj.b,
                        a:'1'
                    }
                })
                this.changeColor(customColor);
                this.setState({
                    customColor: customColor,
                })
                firstlogotype = 'custom'
            }else{
                firstlogotype = 'other'
            }
            this.setState({
                value: type,   // 设置单选默认选择为缓存拿到的type
                themeColor:type,
                firstlogotype:firstlogotype
            })
        } 
        this.setState({
            firstTheme:firstTheme,
            firstCustomColor:firstCustomColor
        })
        document.getElementsByTagName('body')[0].className = type;
    }
    componentDidMount() {
        this.loadTheme();
    }

    onChange = e => {
        let themeColor = e.target.value;
        let customColor = this.state.customColor;
        let logotype ='';
        if (themeColor === 'default') {
            themeColor = 'default'
            // customColor = ''
            logotype = 'other'
        } else if (themeColor === 'blue') {
            themeColor = 'blue'
            // customColor = ''
            logotype = 'other'
        } else if (themeColor === 'red') {
            themeColor = 'red'
            // customColor = ''
            logotype = 'other'
        } else if (themeColor === 'custom') {
            themeColor = 'custom'   //自定义颜色
            logotype = 'custom'
            this.changeColor(customColor);
        }
        this.setState({
            value: e.target.value,
            themeColor: themeColor,
            customColor: customColor,
            logotype:logotype
        });
        this.props.onSelTheme(themeColor,logotype);
    };

    save = () => {
        let themeColor = this.state.themeColor
        let customColor = this.state.customColor
        this.setState({
            firstTheme:themeColor,
            firstCustomColor:customColor
        })
        this.props.onSave(themeColor, customColor);
        this.props.onCancel();
        // window.location.reload();
    }
    onCancel = () => {
        let firstTheme = this.state.firstTheme;
        let firstCustomColor = this.state.firstCustomColor;
        let firstlogotype = this.state.firstlogotype;
        if(firstTheme === 'custom'){
            this.changeColor(firstCustomColor);
        }
        this.setState({
            value: firstTheme,
            themeColor: firstTheme,
        })
        this.props.onSelTheme(firstTheme,firstlogotype);
        this.props.onCancel();
    }

    render() {
        const { visible } = this.props;
        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                    position: 'relative',
                    top: '7px',
                    marginLeft: '10px'
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <Modal
                visible={visible}
                title="设置"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={this.onCancel}
                onOk={this.save}
            >
                <Radio.Group onChange={this.onChange} value={this.state.value}>
                    <Radio value={'default'}>默认</Radio>
                    <Radio value={'blue'}>深空蓝</Radio>
                    <Radio value={'red'}>红色</Radio>
                    <Radio style={{ width: '100%', marginTop: '10px' }} value={'custom'}>自定义
                            <div style={styles.swatch} onClick={this.handleClick}>
                            <div style={styles.color} />
                        </div>
                        {this.state.displayColorPicker ? <div style={styles.popover}>
                            <div style={styles.cover} onClick={this.handleClose} />
                            <SketchPicker color={this.state.color} onChange={this.handleChange} />
                        </div> : null}
                    </Radio>
                </Radio.Group>

            </Modal>
        );
    }
}


export default Theme;